import { Select } from '@/components/forms/Select';
import { useTimezone } from '@/hooks/useTimezone';
import { DISPLAY_TIMEZONES } from '@/lib/datetime';
import { cn } from '@/lib/cn';

interface TimezoneSelectProps {
  compact?: boolean;
  hint?: string;
}

export function TimezoneSelect({ compact = false, hint }: TimezoneSelectProps) {
  const { timezone, setTimezone } = useTimezone();
  const options = DISPLAY_TIMEZONES.some((zone) => zone.value === timezone)
    ? DISPLAY_TIMEZONES
    : [{ value: timezone, label: timezone }, ...DISPLAY_TIMEZONES];

  if (compact) {
    return (
      <label className="hidden items-center sm:flex">
        <span className="sr-only">Display timezone</span>
        <select
          aria-label="Display timezone"
          value={timezone}
          onChange={(event) => setTimezone(event.target.value)}
          className={cn(
            'max-w-[10.5rem] truncate rounded-lg border border-[var(--border-subtle)]',
            'bg-[var(--bg-input)] px-2 py-1.5 text-xs text-[var(--text-primary)]',
            'outline-none hover:bg-[var(--bg-card-hover)] focus:border-[var(--accent)]',
          )}
        >
          {options.map((zone) => (
            <option key={zone.value} value={zone.value}>
              {zone.label}
            </option>
          ))}
        </select>
      </label>
    );
  }

  return (
    <Select
      label="Display timezone"
      hint={hint}
      value={timezone}
      options={options}
      onChange={(event) => setTimezone(event.target.value)}
    />
  );
}
